import apiClient from "./apiClient";

const createOptimizationInput = (
    rebars,
    rebarInformation,
    allFloors,
    separateFloorsChecked,
) => {
    let inputDonatiDict
    if (separateFloorsChecked) {
        inputDonatiDict = Array.from({ length: allFloors.length }, () => ({}));
    }
    else {
        inputDonatiDict = {}
    }
    const rebarCodes = rebars.map(rebar => rebar.code);
    const selectedDiameters = Array.from(new Set(rebars.map(rebar => rebar.diameter.toString())));
    for (let i = 0; i < rebarCodes.length; i++) {
        const rebar = rebarCodes[i]
        const [diameter, length] = rebar.split("-")
        if (!selectedDiameters.includes(diameter)) {
            continue
        }
        /////////////////////////////////////////////////
        if (separateFloorsChecked) {
            const floorIdx = allFloors.indexOf(rebarInformation[rebar]["kat"])
            const inputDonati = inputDonatiDict[floorIdx][`${diameter}-${length}`]
            if (inputDonati) {
                inputDonatiDict[floorIdx][`${diameter}-${length}`]["adet"] += rebarInformation[rebar]["adet"]
                inputDonatiDict[floorIdx][`${diameter}-${length}`]["elemanlar"][rebar] = rebarInformation[rebar]["adet"]
                if (inputDonatiDict[floorIdx][`${diameter}-${length}`]["donatiYerleri"][floorIdx]) {
                    inputDonatiDict[floorIdx][`${diameter}-${length}`]["donatiYerleri"][floorIdx] += rebarInformation[rebar]["adet"]
                }
                else {
                    inputDonatiDict[floorIdx][`${diameter}-${length}`]["donatiYerleri"][floorIdx] = rebarInformation[rebar]["adet"]
                }
            }
            else {
                inputDonatiDict[floorIdx][`${diameter}-${length}`] = {
                    "adet": rebarInformation[rebar]["adet"],
                    "elemanlar": {
                        [rebar]: rebarInformation[rebar]["adet"]
                    }
                }
                inputDonatiDict[floorIdx][`${diameter}-${length}`]["donatiYerleri"] = {}
                inputDonatiDict[floorIdx][`${diameter}-${length}`]["donatiYerleri"][floorIdx] = rebarInformation[rebar]["adet"]
            }
        }
        else {
            const inputDonati = inputDonatiDict[`${diameter}-${length}`]
            if (inputDonati) {
                inputDonatiDict[`${diameter}-${length}`]["adet"] += rebarInformation[rebar]["adet"]
                inputDonatiDict[`${diameter}-${length}`]["elemanlar"][rebar] = rebarInformation[rebar]["adet"]

                const floorIdx = allFloors.indexOf(rebarInformation[rebar]["kat"])
                if (inputDonatiDict[`${diameter}-${length}`]["donatiYerleri"][floorIdx]) {
                    inputDonatiDict[`${diameter}-${length}`]["donatiYerleri"][floorIdx] += rebarInformation[rebar]["adet"]
                }
                else {
                    inputDonatiDict[`${diameter}-${length}`]["donatiYerleri"][floorIdx] = rebarInformation[rebar]["adet"]
                }
            }
            else {
                inputDonatiDict[`${diameter}-${length}`] = {
                    "adet": rebarInformation[rebar]["adet"],
                    "elemanlar": {
                        [rebar]: rebarInformation[rebar]["adet"]
                    }
                }
                const floorIdx = allFloors.indexOf(rebarInformation[rebar]["kat"])
                inputDonatiDict[`${diameter}-${length}`]["donatiYerleri"] = {}
                inputDonatiDict[`${diameter}-${length}`]["donatiYerleri"][floorIdx] = rebarInformation[rebar]["adet"]

            }
        }
    }
    /////////////////////////////////////////////////
    let optimizationInput = {}

    optimizationInput["katSayisi"] = allFloors.length;
    optimizationInput["katlar"] = allFloors;

    optimizationInput["donatiDict"] = rebarInformation;
    optimizationInput["inputDonatiDict"] = inputDonatiDict;

    return optimizationInput;
}

const createCp = async ({
    projectType,
    id,
    cpName,
    optimizationInput = null,
    diameters = null,
    useSubstitutes = null,
    solveFloorByFloor = null,
    minBarLength = null,
    selectedFloors = null,
    availableStocksFile = null,
    optimizationLevel = 3,
}) => {
    const url = `${process.env.REACT_APP_API_URL}/api/optimize/`;

    let formData = new FormData();
    let body;

    if (projectType === 'rebar') {
        body = {
            'projectId': id,
            'cpName': cpName,
            'optimizationInput': optimizationInput,
            'diameters': diameters,
            'useSubstitutes': useSubstitutes,
            'solveFloorByFloor': solveFloorByFloor,
            'minOutageLength': minBarLength,
            'selectedFloors': selectedFloors,
            'optimizationLevel': optimizationLevel,
        }
    }
    else {
        formData.append('projectId', id)
        formData.append('cpName', cpName)
        formData.append('availableStocksFile', availableStocksFile)
        formData.append('optimizationLevel', optimizationLevel)
    }

    let response;
    if (projectType === 'rebar') {
        response = await apiClient(url, {
            method: 'POST',
            body: JSON.stringify(body),
        })
    }
    else {
        response = await apiClient(url, {
            method: 'POST',
            body: formData,
        })
    }
    return response;

};

export { 
    createOptimizationInput,
    createCp 
};
